import { BrowserRouter as Router } from "react-router-dom";
import { SEO, SEOProvider } from "./components/seo";
import { useConnect } from "./hooks/useConnect";
import Pages from "./pages";
import { ClaimrWidgetProvider, useTheme } from "./shared";

import { useEffect, useState } from "react";
import "./app.scss";
import FullScreenLoader from "./components/loader/FullScreenLoader";
import useRegisterDisconnect from "./hooks/useRegisterDisconnect";
import useTokenChecker from "./hooks/useTokenCheker";
import { usePageViewLogger, usePerformanceLogger } from "./hooks/useLogger";
import WalletEventMonitor from "./components/wallet-event-monitor/WalletEventMonitor";

function App() {
  const { theme } = useTheme();
  const { isLoginMessageSigning, isLoading } = useConnect();
  const [mounted, setMounted] = useState(false);

  // Logging hooks
  const { logPageView } = usePageViewLogger();
  const { logCustomPerformance } = usePerformanceLogger('App');

  useEffect(() => {
    setMounted(true);

    // Log initial page load and performance metrics
    const loadTime = performance.now();
    logCustomPerformance('page_load', loadTime, 'ms', {
      pathname: window.location.pathname,
      userAgent: navigator.userAgent,
      referrer: document.referrer || 'direct',
      theme
    });

    // Log initial page view
    logPageView({
      pathname: window.location.pathname,
      title: document.title,
      referrer: document.referrer || 'direct',
      theme,
      isInitialLoad: true
    });
  }, [logPageView, logCustomPerformance, theme]);

  const shouldShowLoader = mounted ? isLoginMessageSigning || isLoading : false;

  useTokenChecker();
  useRegisterDisconnect();

  return (
    <div className={`app ${theme === "dark" ? "dark-theme" : ""}`}>
      <SEOProvider>
        <Router>
          <SEO />
          <ClaimrWidgetProvider>
            <FullScreenLoader isLoading={shouldShowLoader}>
              <Pages />
            </FullScreenLoader>
            {/* Wallet Event Monitor for comprehensive wallet logging */}
            <WalletEventMonitor
              enableDebugLogs={process.env.NODE_ENV === 'development'}
              flushInterval={3000}
            />
          </ClaimrWidgetProvider>
        </Router>
      </SEOProvider>
    </div>
  );
}

export default App;
